/* unplugin-vue-components disabled */import { render } from "./PopupBaseUserInfo.vue?vue&type=template&id=5540ef34&ts=true"
import script from "./PopupBaseUserInfo.vue?vue&type=script&lang=ts"
export * from "./PopupBaseUserInfo.vue?vue&type=script&lang=ts"

import "./PopupBaseUserInfo.vue?vue&type=style&index=0&id=5540ef34&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__